// libs
import React from 'react';

// styles
import './styles.scss';

// component
let GalleryComponent;
if (typeof document !== 'undefined' && document) {
  import('@o2web.ca/museum-viewer').then(({ Gallery }) => {
    GalleryComponent = Gallery;
  });
}

const propTypes = {};

function GalleryWrapper() {
  return (
    <React.Fragment>
      { window && document && <GalleryComponent /> }
    </React.Fragment>
  );
}

GalleryWrapper.propTypes = propTypes;
GalleryWrapper.defaultProps = {};

export default GalleryWrapper;



// WEBPACK FOOTER //
// ./src/app/components/layouts/GalleryWrapper.js